/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import {
    RESET_PC_PIN_VALUES,
    SET_FIRST_PIN_FOR_CHANGING_PIN,
    SET_IS_CHANGE_PIN_OVERLAY_ACTIVE,
    SET_PC_PIN,
    SET_PC_PIN_OVERLAY_UI_PROPS,
    SET_PC_PIN_SPINNER_ACTIVE,
    SET_PC_PIN_SPINNER_DELAY,
    SET_PC_PIN_SUCCESS_CALLBACK,
} from './pcpinoverlay.types';

export const setPcPinAction = (pcPin: string): TivoPayloadAction<{ pcPin: string }> => ({
    type: SET_PC_PIN,
    payload: {
        pcPin,
    },
});

export const setPCPinOnSuccessCallbackAction = (
    onSuccessCallback: Function,
): TivoPayloadAction<{ onSuccessCallback: Function }> => ({
    type: SET_PC_PIN_SUCCESS_CALLBACK,
    payload: {
        onSuccessCallback,
    },
});
export const setPcPinSpinnerActiveAction = (
    spinnerActive: boolean,
): TivoPayloadAction<{ spinnerActive: boolean }> => ({
    type: SET_PC_PIN_SPINNER_ACTIVE,
    payload: {
        spinnerActive,
    },
});

export const setChangePCPinOverlayActiveAction = (
    isChangePCPinOvelayActive: boolean,
): TivoPayloadAction<{ isChangePCPinOvelayActive: boolean }> => ({
    type: SET_IS_CHANGE_PIN_OVERLAY_ACTIVE,
    payload: {
        isChangePCPinOvelayActive,
    },
});

export const setPcPinSpinnerDelayAction = (
    spinnerDelay: number,
): TivoPayloadAction<{ spinnerDelay: number }> => ({
    type: SET_PC_PIN_SPINNER_DELAY,
    payload: {
        spinnerDelay,
    },
});

export const setFirstPcPinAction = (
    firstPCPin: string,
): TivoPayloadAction<{ firstPCPin: string }> => ({
    type: SET_FIRST_PIN_FOR_CHANGING_PIN,
    payload: {
        firstPCPin,
    },
});

export const resetPCPinValuesAction = (
    firstPCPin: string = '',
    isChangePCPinOvelayActive: boolean = false,
    pcPin: string = '',
): TivoPayloadAction<{
    firstPCPin: string;
    isChangePCPinOvelayActive: boolean;
    pcPin: string;
}> => ({
    type: RESET_PC_PIN_VALUES,
    payload: {
        firstPCPin,
        isChangePCPinOvelayActive,
        pcPin,
    },
});

export const setPCPinOverlayProps = (
    overlayUiProps: Partial<IOverlayDialog>,
): TivoPayloadAction<{
    overlayUiProps: Partial<IOverlayDialog>;
}> => ({
    type: SET_PC_PIN_OVERLAY_UI_PROPS,
    payload: {
        overlayUiProps,
    },
});
